import {
  EDITOR_DELETE_SNIPPET_BEGIN,
  EDITOR_DELETE_SNIPPET_SUCCESS,
  EDITOR_DELETE_SNIPPET_FAILURE,
  EDITOR_DELETE_SNIPPET_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../home/app_util';

export function deleteSnippet(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EDITOR_DELETE_SNIPPET_BEGIN,
    });
    const { projectId, version, templateId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const config = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/snippet-templates/${templateId}`,
        config,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: EDITOR_DELETE_SNIPPET_SUCCESS,
              data: res,
              templateId: templateId,
            });
            Mixpanel.track('Deleted Snippet on builder', { uuid: templateId });
            toast.success('Snippet Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EDITOR_DELETE_SNIPPET_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete snippet on builder');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EDITOR_DELETE_SNIPPET_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete snippet on builder');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteSnippetError() {
  return {
    type: EDITOR_DELETE_SNIPPET_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_DELETE_SNIPPET_BEGIN:
      return {
        ...state,
        deleteSnippetPending: true,
        deleteSnippetError: null,
      };

    case EDITOR_DELETE_SNIPPET_SUCCESS:
      return {
        ...state,
        deleteSnippetPending: false,
        deleteSnippetError: null,
        snippets: state.snippets.filter((e) => e.uuid !== action.templateId),
      };

    case EDITOR_DELETE_SNIPPET_FAILURE:
      return {
        ...state,
        deleteSnippetPending: false,
        deleteSnippetError: action.data.error,
      };

    case EDITOR_DELETE_SNIPPET_DISMISS_ERROR:
      return {
        ...state,
        deleteSnippetError: null,
      };

    default:
      return state;
  }
}
